import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { UserContext } from '../context/UserContext';
import './home.css';

export default function MaintenanceLanding({ status }) {
  const { setUser } = useContext(UserContext);
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { email, password });
      setUser(data.user);
      if (data.token) localStorage.setItem('token', data.token);
      // If admin/owner, go to dashboard; else to home
      const roles = Array.isArray(data.user?.roles) ? data.user.roles : [];
      const privileged = roles.includes('admin') || roles.includes('owner') || data.user?.role === 'admin' || data.user?.role === 'owner';
      nav(privileged ? '/dashboard' : '/');
    } catch (e) {
      setError(e?.response?.data?.error || e?.message || 'Login fehlgeschlagen');
    } finally { setLoading(false); }
  };

  const untilText = status?.until ? new Date(status.until).toLocaleString() : null;

  return (
    <div className="home-page" style={{ width:'100vw', margin:0, padding:0 }}>
      <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
        <h2 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Wartungsmodus aktiv</h2>
        {status?.message && (
          <p className="hero-desc" style={{ maxWidth:760, margin:'0 auto 12px auto' }}>{status.message}</p>
        )}
        {untilText && (
          <p className="hero-desc" style={{ opacity:.9 }}>Voraussichtlich bis: {untilText}</p>
        )}
      </section>

      <section style={{ width:'100%', maxWidth: 520, margin:'0 auto', padding:'0 16px 40px 16px' }}>
        <form className="highlight-card" style={{ gap: 16, padding: 24 }} onSubmit={e => { e.preventDefault(); handleLogin(); }}>
          <h2 className="highlight-title" style={{ marginBottom: 4 }}>Direktlogin für Mitglieder</h2>
          <input
            className="hero-btn-secondary"
            style={{ padding:'12px 16px', fontSize:'1rem' }}
            placeholder="E-Mail"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <div style={{ position:'relative', height:48 }}>
            <input
              className="hero-btn-secondary"
              style={{ padding:'12px 16px', fontSize:'1rem', width:'100%' }}
              type={showPassword ? 'text' : 'password'}
              placeholder="Passwort"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <button
              type="button"
              aria-label={showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'}
              onClick={() => setShowPassword(v => !v)}
              style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:0, cursor:'pointer', color:'#32CD89', fontSize:'1.2em', padding:'0 4px', lineHeight:1 }}
            >
              {showPassword ? '🙈' : '👁️'}
            </button>
          </div>
          {error && <div style={{ color:'tomato', fontSize:14 }}>{error}</div>}
          <button type="submit" className="hero-btn-primary" disabled={loading}>
            {loading ? 'Einloggen …' : 'Einloggen'}
          </button>
        </form>
        <div style={{ fontSize:12, opacity:.75, textAlign:'center', marginTop:8 }}>
          Hinweis: Während des Wartungsmodus können sich nur Administratoren anmelden, sofern die allgemeine Anmeldung deaktiviert wurde.
        </div>
      </section>
    </div>
  );
}
